import Slider from "./Slider.container";
export default Slider;
